var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.031,
    height: 40.458,
    viewBox: "0 0 49.031 40.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud",
    transform: "translate(1.008 1.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6939",
    "data-name": "Path 6939",
    d: "M25.092,20.546,16.546,12,8,20.546",
    transform: "translate(6.967 7.223)",
    fill: "none",
    stroke: "#f38a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    y2: 19.228,
    transform: "translate(23.513 19.223)",
    fill: "none",
    stroke: "#f38a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6940",
    "data-name": "Path 6940",
    d: "M42.432,35.878a10.682,10.682,0,0,0-5.106-20.061H34.634a17.092,17.092,0,1,0-29.355,15.6",
    transform: "translate(-0.995 -3.002)",
    fill: "none",
    stroke: "#f38a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6941",
    "data-name": "Path 6941",
    d: "M25.092,20.546,16.546,12,8,20.546",
    transform: "translate(6.967 7.223)",
    fill: "none",
    stroke: "#f38a3a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.3c31ea104dee4efb0593807e18dcd317.svg";
export { ForwardRef as ReactComponent };